import dayjs from 'dayjs';
import { Loader } from '@piggytechng/component-library';
import NoData from '../NoData/NoData';
import useInterestBreakdown from '../../hooks/useInterestBreakdown';
import { formatToDollar, formatToNaira } from '../../helpers/utils';
import { InterestBreakdownProps } from '../../types';

const InterestBreakdown = ({ walletName, targetId, loaderColor = '#1734ca' }: InterestBreakdownProps) => {
  const { interestBreakdown, isLoadingInterestBreakdown } = useInterestBreakdown(walletName, targetId);

  const isDollar = String(interestBreakdown?.symbol).toLowerCase() === 'usd';
  const currency = isDollar ? '$' : '₦';
  const format = (val: number) => (isDollar ? formatToDollar(val) : formatToNaira(val));

  if (isLoadingInterestBreakdown) {
    return (
      <div className="page-loader">
        <Loader color={loaderColor} />
      </div>
    );
  }

  if (!interestBreakdown?.list?.length) {
    return <NoData message={'No interest breakdown at the moment.'} />;
  }

  return (
    <div className="table-container housemoney piggybank">
      <table className="table">
        <thead className="table_head">
          <tr>
            <th className="date">Date Paid</th>
            <th className="amount">{`Interest On Balance (${currency})`}</th>
            <th className="balance">{`Balance (${currency})`}</th>
          </tr>
        </thead>

        <tbody className="table-body">
          {interestBreakdown.list.map((entry: any, idx: number) => (
            <tr key={entry.unixTimeStamp || idx} className="table-row">
              <td className="date">{dayjs.unix(entry.unixTimeStamp).format('D MMM YYYY')}</td>
              <td className="amount">{format(entry.interestOnBalance)}</td>
              <td className="balance">{format(entry.balance)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InterestBreakdown;
